export const obtenerDatoUrl =  ({clave}) => {

    const parametros = new URLSearchParams(window.location.search);

    // Extrae específicamente el valor de 'id'
    return parametros.get(clave);

}